const cartDrawer = document.getElementById('cart-drawer');
let codWrapper = document.getElementById('cart-wrapper');

const placeCodButton = () => {
  const slot = document.querySelector('[data-vp-cod-slot]');
  const wrapper = document.getElementById('cart-wrapper');
  if (wrapper) codWrapper = wrapper;
  if (slot && codWrapper && codWrapper.parentElement !== slot) slot.append(codWrapper);
};

new MutationObserver(placeCodButton).observe(document.body, { childList: true, subtree: true });
placeCodButton();

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('#rsi_buy_now_button, .vp-cod');
  if (!button) return;
  if (document.querySelector('[data-vp-cart-state][data-vp-subscription="true"]')) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }
  const dialog = cartDrawer?.querySelector('dialog');
  if (cartDrawer?.contains(button) && dialog?.open) cartDrawer.close();
}, true);

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('.vp-menu-nav a');
  if (link) link.closest('header-drawer')?.close();
});

